import * as React from "react";
import { Button } from 'baseui/button';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalButton,
  } from 'baseui/modal';
  // api
import { useDeleteObjectMutation } from '../../services/objects'
import { AccessRoles, useHasRole } from "../../hooks/useHasRole";

export const DeleteObjectButton = ({ resourceGroupId, objectId, objectName }: any) => {
    const hasAccess = useHasRole(AccessRoles.Object.Delete);
    const [isOpen, setIsOpen] = React.useState(false);
    const [deleteObject, deleteObjectResult] = useDeleteObjectMutation();
    const onDeleteObjectClick = (e: any) => { deleteObject({ id: objectId, resourceGroupId: resourceGroupId}); setIsOpen(false)}

    function close() {
        setIsOpen(false);
      }

    return (
        <>
            <Button disabled={!hasAccess} onClick={() => setIsOpen(true)} isLoading={deleteObjectResult.isLoading}>Delete</Button>
            <Modal onClose={close} isOpen={isOpen}>
                <ModalHeader>Delete Object</ModalHeader>
                <ModalBody>
                    Do you really want to delete '{objectName}'?
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={close}>
                        Cancel
                    </ModalButton>
                    <ModalButton onClick={onDeleteObjectClick} isLoading={deleteObjectResult.isLoading}>Okay</ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}